import { createFileRoute } from "@tanstack/react-router";

import { CheckAiResumeEditsGuide, getCheckAiResumeEditsGuideMetadata } from "@/components/guides/check-ai-resume-edits";

export const Route = createFileRoute("/_home/guides/check-ai-resume-edits")({
  component: CheckAiResumeEditsGuide,
  head: () => {
    const metadata = getCheckAiResumeEditsGuideMetadata();

    return {
      meta: [
        { title: metadata.title },
        { name: "description", content: metadata.description },
        { property: "og:title", content: metadata.title },
        { property: "og:description", content: metadata.description },
        { property: "og:url", content: metadata.ogUrl },
        { property: "twitter:title", content: metadata.title },
        { property: "twitter:description", content: metadata.description },
      ],
    };
  },
});
